import { createActionType } from '../../helpers';

const domain = 'sidebar';

const expandSidebar = createActionType(domain, 'expandSidebar');
const collapseSidebar = createActionType(domain, 'collapseSidebar');


export default {
  expandSidebar,
  collapseSidebar,
};
